import {Component, HostListener, Input, OnInit} from '@angular/core';

import {PlayerService} from '../../core/services/player/player.service';

@Component({
  selector: 'psr-player-controls',
  templateUrl: './player-controls.component.html',
  styleUrls: ['./player-controls.component.scss']
})
export class PlayerControlsComponent implements OnInit {

  @Input() onlyPlayButton = false;

  public showingInfo = false;
  public playing = false;
  public muted = false;
  public volume = 90;
  private oldVolume: number = this.volume;

  constructor(private playerService: PlayerService) {
  }

  ngOnInit(): void {
    this.volume = this.playerService.volume;
    this.playerService.isPlaying.subscribe(isPlaying => this.playing = isPlaying);
    this.playerService.currentlyPlaying.subscribe(currentlyPlaying => {
      if (currentlyPlaying) {
        this.playing = true;
      }
    });
  }

  setVolume($event?): void {
    if (!!$event) {
      $event.stopPropagation();
    }

    this.muted = false;

    if (this.volume < 5) {
      this.volume = 0;
    }

    this.playerService.volume = this.volume;
  }

  toggleMute($event?): void {
    if (!!$event) {
      $event.stopPropagation();
    }

    if (this.muted) {
      this.unmuteVolume();
    } else {
      this.muteVolume();
    }
  }

  togglePlay($event?): void {
    if (!!$event) {
      $event.stopPropagation();
    }

    if (this.playing) {
      this.playerService.pause();
    } else {
      this.playerService.play();
    }
  }

  muteVolume($event?): void {
    if (!!$event) {
      $event.stopPropagation();
    }

    this.oldVolume = this.volume;
    this.volume = 0;
    this.setVolume();
    this.muted = true;
  }

  unmuteVolume($event?): void {
    if (!!$event) {
      $event.stopPropagation();
    }

    this.muted = false;
    this.volume = this.oldVolume;
    this.setVolume();
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent): void {
    if (event.code === 'Space') {
      this.togglePlay();
    } else if (event.code === 'KeyM') {
      this.toggleMute();
    }
  }

  toggleInfo($event?): void {
    if (!!$event) {
      $event.stopPropagation();
    }

    this.showingInfo = !this.showingInfo;

    this.playerService.toggleInfo();
  }
}
